import { render, staticRenderFns } from "./GPFUPSettings.vue?vue&type=template&id=5078befc&"
import script from "./GPFUPSettings.vue?vue&type=script&lang=ts&"
export * from "./GPFUPSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GPFUPSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports